import { env } from "../../env";
var domain;
if (env.REACT_APP_ENV === "development") {
    domain = "http://localhost:3000";
} else if (env.REACT_APP_ENV === "uat") {
    domain = env.REACT_APP_DOMAIN_UAT;
} else {
    domain = env.REACT_APP_DOMAIN_PROD;
}
export { domain };
export var apiUrl = "/api/v1";
export var COMPANY_LOGO = env.REACT_APP_COMPANY_LOGO_URL;
export var YES = "YES";
export var NO = "NO";
export var OK = "OK";
export var TOKEN = "TOKEN";
export var VER = "1.0.1";
export var endPoint = {
    STOCK_COUNT_LIST: "".concat(apiUrl, "/bo-stock-count/list"),
    STOCK_COUNT_EXPORT_EXCEL: "".concat(apiUrl, "/bo-stock-count/export-excel"),
    STOCK_COUNT_CREATE: "".concat(apiUrl, "/bo-stock-count/create"),
    STOCK_COUNT_TRANSITION: "".concat(apiUrl, "/bo-stock-count/transition"),
    STOCK_COUNT_DELETE: "".concat(apiUrl, "/bo-stock-count/delete"),
    STOCK_COUNT_ITEMS: "".concat(apiUrl, "/bo-stock-count/items"),
    STOCK_COUNT_PRODUCTS: "".concat(apiUrl, "/bo-stock-count/products"),
    STOCK_COUNT_BRANDS: "".concat(apiUrl, "/bo-stock-count/brands"),
    STOCK_COUNT_ADD_ITEM: "".concat(apiUrl, "/bo-stock-count/add-item"),
    STOCK_COUNT_REDUCE_ITEM: "".concat(apiUrl, "/bo-stock-count/reduce-item"),
    STOCK_COUNT_CANCEL_ITEM: "".concat(apiUrl, "/bo-stock-count/cancel-item"),
    STOCK_COUNT_LOGS: "".concat(apiUrl, "/bo-stock-count/logs"),
    SYNC_PRODUCT: "".concat(apiUrl, "/bo-product-sync/product"),
    SYNC_SHOP: "".concat(apiUrl, "/bo-shshop/sync-erp-shop"),
    SYNC_SHOP_BRANCH: "".concat(apiUrl, "/bo-shshop/sync-erp-shop"),
    SYNC_PRODUCT_TYPE: "".concat(apiUrl, "/bo-product-master-sync/product-type"),
    SYNC_PRODUCT_CATEGORY: "".concat(apiUrl, "/bo-product-master-sync/main-category"),
    SYNC_PRODUCT_SUB_CATEGORY: "".concat(apiUrl, "/bo-product-master-sync/sub-category"),
    SYNC_BRAND: "".concat(apiUrl, "/bo-product-master-sync/brand"),
    SHOP_PRODUCT_BAN_LIST: "".concat(apiUrl, "/bo-shop-product-ban/list"),
    SHOP_PRODUCT_BAN_OPTIONS: "".concat(apiUrl, "/bo-shop-product-ban/options"),
    SHOP_PRODUCT_BAN_SAVE: "".concat(apiUrl, "/bo-shop-product-ban/save"),
    BRANCH_SPECIAL_PRICE_BRANCHES: "".concat(apiUrl, "/bo-branch-special-price/branches"),
    BRANCH_SPECIAL_PRICE_PRODUCTS: "".concat(apiUrl, "/bo-branch-special-price/products"),
    BRANCH_SPECIAL_PRICE_SAVE: "".concat(apiUrl, "/bo-branch-special-price/save"),
    LOGIN_URL: "".concat(apiUrl, "/authbackoffice/login"),
    VERIFY_ROLE_LOG: "".concat(apiUrl, "/verify-role-log"),
    NEW_ALLDERNOW_USER: "".concat(apiUrl, "/new-alldernow-user"),
    USER_INFO: "".concat(apiUrl, "/new-alldernow-user/get-user-info"),
    GET_MENU: "".concat(apiUrl, "/bo-menu"),
    MST_PREFIX_URL: "".concat(apiUrl, "/mst-prefix"),
    MST_SEX_URL: "".concat(apiUrl, "/mst-sex"),
    MST_MARITAL_STATUS: "".concat(apiUrl, "/mst-marital-status"),
    MST_MILITARY_STATUS: "".concat(apiUrl, "/mst-military-status"),
    MST_RELATIONSHIP: "".concat(apiUrl, "/mst-relationship"),
    MST_EMPLOYEE_TYPE: "".concat(apiUrl, "/mst-employee-type"),
    MST_DEPARTMENT: "".concat(apiUrl, "/mst-department"),
    MST_POSITION: "".concat(apiUrl, "/mst-position"),
    MST_BANK: "".concat(apiUrl, "/mst-bank"),
    MST_BANK_ACCOUNT_TYPE: "".concat(apiUrl, "/mst-bank-account-type"),
    MST_EMPLOYEE_DOC: "".concat(apiUrl, "/mst-employee-doc"),
    MST_BRANCH: "".concat(apiUrl, "/mst-branch"),
    MST_BUSINESS_TYPE: "".concat(apiUrl, "/mst-business-type"),
    MST_BUSINESS_CATEGORY: "".concat(apiUrl, "/mst-business-category"),
    MST_COMPANY_PREFIX: "".concat(apiUrl, "/mst-company-prefix"),
    MST_PAYMENT_METHOD: "".concat(apiUrl, "/mst-payment-method"),
    MST_PAYMENT_TERM: "".concat(apiUrl, "/mst-payment-term"),
    MST_SUPPLIER_DOC: "".concat(apiUrl, "/mst-supplier-doc"),
    MST_NEW_ALLDERNOW_ROLE: "".concat(apiUrl, "/mst-new-alldernow-role"),
    MST_PAYMENT_TYPE: "".concat(apiUrl, "/mst-payment-type"),
    MST_DISCOUNT_TYPE: "".concat(apiUrl, "/mst-discount-type"),
    MST_PRICE_CATEGORY: "".concat(apiUrl, "/mst-price-category"),
    MST_VAT: "".concat(apiUrl, "/mst-vat"),
    WAREHOUSE: "".concat(apiUrl, "/warehouse"),
    MASTER_BRAND: "".concat(apiUrl, "/master-brand"),
    MASTER_MAIN_CATEGORY: "".concat(apiUrl, "/master-main-category"),
    MST_NEW_ITEM_PR_COL: "".concat(apiUrl, "/mst-new-item-pr-col"),
    MST_OFFICE_SECTION: "".concat(apiUrl, "/mst-office-section"),
    MST_COMPANY: "".concat(apiUrl, "/mst-company/find-first"),
    MST_MART: "".concat(apiUrl, "/mst-mart/find-first"),
    MST_ADD_COST: "".concat(apiUrl, "/mst-add-cost"),
    MST_ADD_COST_UNIT: "".concat(apiUrl, "/mst-add-cost-unit"),
    MST_NEW_ITEM_EXPENSE_COL: "".concat(apiUrl, "/mst-new-item-expense-col"),
    MST_WITHHOLDING_TAX: "".concat(apiUrl, "/mst-withholding-tax"),
    MST_EXPENSE_TYPE: "".concat(apiUrl, "/mst-expense-type"),
    NEW_ALLDERNOW_EMP: "".concat(apiUrl, "/new-alldernow-emp"),
    GROUP_OF_SUPPLIER: "".concat(apiUrl, "/group-of-supplier"),
    SUPPLIER_INFORMATION: "".concat(apiUrl, "/supplier-information"),
    PRODUCT_PRICE: "".concat(apiUrl, "/product-price"),
    NEW_PURCHASE_REQ: "".concat(apiUrl, "/new-purchase-req"),
    NEW_PURCHASE_ORDER: "".concat(apiUrl, "/new-purchase-order"),
    NEW_PO_SPLIT: "".concat(apiUrl, "/new-po-split"),
    NEW_GR: "".concat(apiUrl, "/new-gr"),
    HISTORY_BRANCH_ADDRESS: "".concat(apiUrl, "/history-branch-address"),
    EXPENSE: "".concat(apiUrl, "/expense"),
    REPORT_PURCHASE_PRODUCT_PO_ITEM: "".concat(apiUrl, "/report-purchase-product-po-item"),
    REPORT_PURCHASE_SUPPLIER: "".concat(apiUrl, "/report-purchase-supplier"),
    REPORT_PURCHASE_ORDER: "".concat(apiUrl, "/report-purchase-order"),
    REPORT_RECEIVE_PRODUCT_GR_ITEM: "".concat(apiUrl, "/report-receive-product-gr-item"),
    REPORT_MAPS: "".concat(apiUrl, "/bo-maps"),
    REPORT_APPOINTMENT: "".concat(apiUrl, "/bo-appointment"),
    // Avengosoft Dev
    PARTNER_INFO: "".concat(apiUrl, "/bo-business"),
    PARTNER_STATUS: "".concat(apiUrl, "/bo-business/update-status"),
    PARTNER_BANK: "".concat(apiUrl, "/bo-business/businessbank"),
    PARTNER_DOC: "".concat(apiUrl, "/bo-business/businessdoc"),
    PARTNER_PRODUCT: "".concat(apiUrl, "/bo-business/businessproduct"),
    PARTNER_COMMENT: "".concat(apiUrl, "/bo-business/businesscomment"),
    PROVINCE_URL: "".concat(apiUrl, "/get-sys/province"),
    COUNTRIES_URL: "".concat(apiUrl, "/get-sys/countries"),
    LAO_PROVINCE_URL: "".concat(apiUrl, "/get-sys/lao-province"),
    LAO_DISTRICT_URL: "".concat(apiUrl, "/get-sys/lao-district"),
    LAO_VILLAGE_URL: "".concat(apiUrl, "/get-sys/lao-village"),
    DISTRICT_URL: "".concat(apiUrl, "/get-sys/district"),
    SUBDISTRICT_URL: "".concat(apiUrl, "/get-sys/subdistrict"),
    PRODUCT_INFO: "".concat(apiUrl, "/bo-presentation"),
    PRODUCT_STATUS: "".concat(apiUrl, "/bo-presentation/update-status"),
    PRODUCT_DETAIL: "".concat(apiUrl, "/bo-presentation/product"),
    PARTNER_CREATE_COMMENT: "".concat(apiUrl, "/bo-business/create-comment"),
    PARTNER_UPDATE_COMMENT: "".concat(apiUrl, "/bo-business/update-comment"),
    PRODUCTTYPE: "".concat(apiUrl, "/get-sys/producttype"),
    CATEGORY: "".concat(apiUrl, "/get-sys/productcategory"),
    SUBCATEGORY: "".concat(apiUrl, "/get-sys/productcategorysub"),
    PRODUCT_COMMENT: "".concat(apiUrl, "/bo-presentation/createcomment"),
    EVIDENCETYPE: "".concat(apiUrl, "/get-sys/evidencetype"),
    MASTER_UNIT: "".concat(apiUrl, "/get-sys/unit"),
    MASTER_UNITWEIGHT: "".concat(apiUrl, "/get-sys/unitweight"),
    MASTER_DIMENSION: "".concat(apiUrl, "/get-sys/dimension"),
    PARTNER_STATUS_BANK: "".concat(apiUrl, "/bo-business/update-bank-status"),
    PARTNER_STATUS_DOC: "".concat(apiUrl, "/bo-business/update-doc-status"),
    MASTER_TYPE_DOCUMENT: "".concat(apiUrl, "/get-sys/document"),
    MASTER_TYPE_FILE_PRODUCT: "".concat(apiUrl, "/get-sys/productfiletype"),
    CONTRACT_INFO: "".concat(apiUrl, "/bo-contract/getdatacontract"),
    MASTER_BUSINESS: "".concat(apiUrl, "/get-sys/business"),
    CONTRACT_BANK: "".concat(apiUrl, "/get-sys/businessbankbyid"),
    CONTRACT_PRODUCT: "".concat(apiUrl, "/bo-contract/getproductinfo"),
    CONTRACT_BRANCH_POSITION: "".concat(apiUrl, "/get-sys/branchbyposition"),
    CONTRACT_BRANCH_POINT: "".concat(apiUrl, "/get-sys/branchbyadpoint"),
    CONTRACT_CREATE: "".concat(apiUrl, "/bo-contract/createcontract"),
    CONTRACT_UPDATE: "".concat(apiUrl, "/bo-contract/updatecontract"),
    CONTRACT_BY_ID: "".concat(apiUrl, "/bo-contract/getctcontractinfo"),
    CONTRACT_PD_BY_ID: "".concat(apiUrl, "/bo-contract/getctproductinfo"),
    CONTRACT_PLACE_BY_ID: "".concat(apiUrl, "/bo-contract/getctplacementinfo"),
    CONTRACT_ADS_BY_ID: "".concat(apiUrl, "/bo-contract/getctadvertinfo"),
    CONTRACT_UP_STATUS: "".concat(apiUrl, "/bo-contract/updatestatuscontract"),
    CONTRACT_UPLOAD_FILE: "".concat(apiUrl, "/bo-contract/upload_contract"),
    CONTRACT_APPROVE_FILE: "".concat(apiUrl, "/bo-contract/updateapprovefile"),
    CONTRACT_FILE_BY_ID: "".concat(apiUrl, "/bo-contract/getctfileinfo"),
    CONTRACT_UPDATE_FILE: "".concat(apiUrl, "/bo-contract/updatefile"),
    CONTRACT_UPDATE_DEL: "".concat(apiUrl, "/bo-contract/updatedeletecontract"),
    CONTRACT_BANK_INFO: "".concat(apiUrl, "/bo-contract/getctbankinfo"),
    CONTRACT_BILLING_INFO: "".concat(apiUrl, "/bo-contract/getbillinginfo"),
    QUOTATION_INFO_ALL: "".concat(apiUrl, "/bo-quotation/getdataquotation"),
    QUOTATION_UPDATE_DEL: "".concat(apiUrl, "/bo-quotation/updatedeletequotation"),
    QUOTATION_CREATE: "".concat(apiUrl, "/bo-quotation/createquotation"),
    QUOTATION_UPDATE: "".concat(apiUrl, "/bo-quotation/updatequotation"),
    QUOTATION_UPDATE_FILE: "".concat(apiUrl, "/bo-quotation/upload_quotation"),
    QUOTATION_INFO_BY_ID: "".concat(apiUrl, "/bo-quotation/getqrquotation"),
    QUOTATION_FILE_BY_ID: "".concat(apiUrl, "/bo-quotation/getqrfile"),
    QUOTATION_DETAIL_BY_ID: "".concat(apiUrl, "/bo-quotation/getqrdetail"),
    QUOTATION_UPDATE_STATUS: "".concat(apiUrl, "/bo-quotation/updatestatusquotation"),
    QUOTATION_GET_CONTRACT: "".concat(apiUrl, "/bo-quotation/getdatacontractinfo"),
    BILL: "".concat(apiUrl, "/bo-billing"),
    BILL_QUOTATION: "".concat(apiUrl, "/bo-billing/quotationlist"),
    CREATE_BILL: "".concat(apiUrl, "/bo-billing/create"),
    UPDATE_BILL: "".concat(apiUrl, "/bo-billing/update"),
    UPLOAD_BILL: "".concat(apiUrl, "/bo-billing/upload_tmp_billing"),
    INVOICE: "".concat(apiUrl, "/bo-invoice"),
    CREATE_INVOICE: "".concat(apiUrl, "/bo-invoice/create"),
    UPDATE_INVOICE: "".concat(apiUrl, "/bo-invoice/update"),
    GETQUOTATION: "".concat(apiUrl, "/bo-billing/quotation"),
    UPLOAD_INVOICE: "".concat(apiUrl, "/bo-invoice/upload_tmp_invoice"),
    CREATE_BYBILLING: "".concat(apiUrl, "/bo-invoice/createbybilling"),
    BRANCH: "".concat(apiUrl, "/bo-branch"),
    CREATE_BRANCH: "".concat(apiUrl, "/bo-branch/create"),
    UPDATE_BRANCH: "".concat(apiUrl, "/bo-branch/update"),
    DELETE_BRANCH: "".concat(apiUrl, "/bo-branch/delete"),
    POSITION: "".concat(apiUrl, "/bo-position"),
    CREATE_POSITION: "".concat(apiUrl, "/bo-position/create"),
    UPDATE_POSITION: "".concat(apiUrl, "/bo-position/update"),
    DELETE_POSITION: "".concat(apiUrl, "/bo-position/delete"),
    ADPOINT: "".concat(apiUrl, "/bo-adpoint"),
    CREATE_ADPOINT: "".concat(apiUrl, "/bo-adpoint/create"),
    UPDATE_ADPOINT: "".concat(apiUrl, "/bo-adpoint/update"),
    DELETE_ADPOINT: "".concat(apiUrl, "/bo-adpoint/delete"),
    MST_PROMOTYPE: "".concat(apiUrl, "/set-promotype"),
    PROMOTION: "".concat(apiUrl, "/bo-promotion"),
    CREATE_PROMOTION: "".concat(apiUrl, "/bo-promotion/create"),
    UPDATE_PROMOTION: "".concat(apiUrl, "/bo-promotion/update"),
    DELETE_PROMOTION: "".concat(apiUrl, "/bo-promotion/delete"),
    ALL_BRAND: "".concat(apiUrl, "/bo-brand/getdatabrand"),
    CREATE_BRAND: "".concat(apiUrl, "/bo-brand/createbrand"),
    UPDATE_BRAND: "".concat(apiUrl, "/bo-brand/updatebrand"),
    DELETE_BRAND: "".concat(apiUrl, "/bo-brand/deletebrand"),
    MST_BRANDS: "".concat(apiUrl, "/get-sys/brand"),
    BILL_CANCEL: "".concat(apiUrl, "/bo-billing/update-cancel"),
    INVOICE_CANCEL: "".concat(apiUrl, "/bo-invoice/update-cancel"),
    SETTING_PD_TYPE_INFO: "".concat(apiUrl, "/bo-pdtype/getdatapdtype"),
    SETTING_PD_TYPE_CREATE: "".concat(apiUrl, "/bo-pdtype/createpdtype"),
    SETTING_PD_TYPE_UPDATE: "".concat(apiUrl, "/bo-pdtype/updatepdtype"),
    SETTING_PD_TYPE_DELETE: "".concat(apiUrl, "/bo-pdtype/deletepdtype"),
    SETTING_PD_CATE_INFO: "".concat(apiUrl, "/bo-pdcate/getdatapdcate"),
    SETTING_PD_CATE_CREATE: "".concat(apiUrl, "/bo-pdcate/createpdcate"),
    SETTING_PD_CATE_UPDATE: "".concat(apiUrl, "/bo-pdcate/updatepdcate"),
    SETTING_PD_CATE_DELETE: "".concat(apiUrl, "/bo-pdcate/deletepdcate"),
    SETTING_PD_SUBCATE_INFO: "".concat(apiUrl, "/bo-pdcatesub/getdatapdcatesub"),
    SETTING_PD_SUBCATE_CREATE: "".concat(apiUrl, "/bo-pdcatesub/createpdcatesub"),
    SETTING_PD_SUBCATE_UPDATE: "".concat(apiUrl, "/bo-pdcatesub/updatepdcatesub"),
    SETTING_PD_SUBCATE_DELETE: "".concat(apiUrl, "/bo-pdcatesub/deletepdcatesub"),
    GET_CLBOOK: "".concat(apiUrl, "/bo-clbook"),
    ALL_CLBOOK: "".concat(apiUrl, "/bo-clbook/getdataclbook"),
    CREATE_CLBOOK: "".concat(apiUrl, "/bo-clbook/createclbook"),
    UPDATE_CLBOOK: "".concat(apiUrl, "/bo-clbook/updateclbook"),
    UPDATESTAUST_CLBOOK: "".concat(apiUrl, "/bo-clbook/updatestatusclbook"),
    DELETE_CLBOOK: "".concat(apiUrl, "/bo-clbook/deleteclbook"),
    COPY_CLBOOK: "".concat(apiUrl, "/bo-clbook/copyclbook"),
    ALL_CATALOG: "".concat(apiUrl, "/bo-catalog"),
    ALL_PRODUCT: "".concat(apiUrl, "/bo-catalog/product-list"),
    UPDATESTAUST_CATALOG: "".concat(apiUrl, "/bo-catalog/updatestatus"),
    UPDATESTAUST_NEW: "".concat(apiUrl, "/bo-catalog/updatenew"),
    UPDATESTAUST_RECOM: "".concat(apiUrl, "/bo-catalog/updaterecom"),
    GETPROMO: "".concat(apiUrl, "/get-sys/promotion"),
    CREATE_CATALOG: "".concat(apiUrl, "/bo-catalog/create"),
    DELETE_CATALOG: "".concat(apiUrl, "/bo-catalog/delete"),
    DELETE_OPEN_CATALOG: "".concat(apiUrl, "/bo-catalog/opendelete"),
    UPDATE_DETAIL_CATALOG: "".concat(apiUrl, "/bo-catalog/updatedetail"),
    UPDATE_CATALOG: "".concat(apiUrl, "/bo-catalog/update"),
    DATASHOP: "".concat(apiUrl, "/bo-shshop/getdatashshop"),
    DATASHOPBYID: "".concat(apiUrl, "/bo-shshop/getdatashshopbyid"),
    DATASHOPID: "".concat(apiUrl, "/bo-shshop/getdatashshopbranch"),
    CREATE_SHOP: "".concat(apiUrl, "/bo-shshop/createshshop"),
    UPDATE_SHOP: "".concat(apiUrl, "/bo-shshop/updateshshop"),
    DELETE_SHOP: "".concat(apiUrl, "/bo-shshop/deleteshshop"),
    UPLOAD_SHOP: "".concat(apiUrl, "/bo-shshop/upload_shshop"),
    UPDATESTATUS_SHOP: "".concat(apiUrl, "/bo-shshop/updatestatusshshop"),
    SALE: "".concat(apiUrl, "/get-sys/saleuser"),
    CREATE_SHBRANCH: "".concat(apiUrl, "/bo-shshop/createshshopbranch"),
    UPDATE_SHBRANCH: "".concat(apiUrl, "/bo-shshop/updateshshopbranch"),
    UPDATESTATUS_SHBRANCH: "".concat(apiUrl, "/bo-shshop/updatestatusshshopbranch"),
    DELETE_SHBRANCH: "".concat(apiUrl, "/bo-shshop/deleteshshopbranch"),
    SHBRANCHID: "".concat(apiUrl, "/bo-shshop/getdatashshopbranchbyid"),
    SET_SHIPPING: "".concat(apiUrl, "/bo-shshop/setshipping"),
    MST_SYSROLE: "".concat(apiUrl, "/sys-role"),
    DELETE_SYSROLE: "".concat(apiUrl, "/sys-role/delete"),
    CREATE_SYSROLE: "".concat(apiUrl, "/sys-role/create"),
    UPDATE_SYSROLE: "".concat(apiUrl, "/sys-role/update"),
    UPDATE_STATUS_SYSROLE: "".concat(apiUrl, "/sys-role/update-status"),
    SYSROLE_MENUS: "".concat(apiUrl, "/sys-role/menus"),
    SETUSER: "".concat(apiUrl, "/bo-setuser"),
    CREATE_SETUSER: "".concat(apiUrl, "/bo-setuser/create"),
    UPDATE_SETUSER: "".concat(apiUrl, "/bo-setuser/update"),
    RESERVATION_INFO_ALL: "".concat(apiUrl, "/bo-rsreserve/getdatarsreserve"),
    RESERVATION_UPDATE_SALES: "".concat(apiUrl, "/bo-rsreserve/updatesalestatus"),
    RESERVATION_UPDATE_STATUS: "".concat(apiUrl, "/bo-rsreserve/updateadminstatus"),
    RESERVATION_INFO_BY_ID: "".concat(apiUrl, "/bo-rsreserve/getdatarsreservebyid"),
    RESERVATION_CATALOG_BY_ID: "".concat(apiUrl, "/bo-rsreserve/getdatarsdetailbyrsid"),
    RESERVATION_UPDATE_LIST: "".concat(apiUrl, "/bo-rsreserve/updatersreserve"),
    RESERVATION_DELETE: "".concat(apiUrl, "/bo-rsreserve/deletereservcatalogid"),
    RESERVATION_CATALOG_ALL: "".concat(apiUrl, "/bo-rsreserve/getcatalog"),
    RESERVATION_CATALOG_CREATE: "".concat(apiUrl, "/bo-rsreserve/createrscatalog"),
    RESERVATION_CREATE: "".concat(apiUrl, "/bo-rsreserve/creatersreserve"),
    PRODUCT_DATALIST: "".concat(apiUrl, "/bo-pd-product/post-product-info"),
    UPLOAD_PRODUCT: "".concat(apiUrl, "/bo-pd-product/upload_tmp_product"),
    DETAILPRODUCT: "".concat(apiUrl, "/bo-pd-product/post-product-detail"),
    MASTER_CHANNEOFFLINE: "".concat(apiUrl, "/get-sys/channeloffline"),
    MASTER_CHANNEONLINE: "".concat(apiUrl, "/get-sys/channelonline"),
    MASTER_PRODUCTFILE: "".concat(apiUrl, "/get-sys/productfiletype"),
    UPDATE_PRODUCT: "".concat(apiUrl, "/bo-pd-product/updateproduct"),
    ALL_SHOP: "".concat(apiUrl, "/get-sys/setshop"),
    ALL_SHOPBRANCH: "".concat(apiUrl, "/get-sys/setshopbranch"),
    GET_VISIT: "".concat(apiUrl, "/bo-visit/getdatavisit"),
    GET_SHOP: "".concat(apiUrl, "/get-sys/shop"),
    GET_SHOP_RESERVATION_CREATE: "".concat(apiUrl, "/get-sys/shop-reservation-create"),
    GET_OBJE: "".concat(apiUrl, "/get-sys/setobjective"),
    CREATE_VISIT: "".concat(apiUrl, "/bo-visit/createvisit"),
    UPDATE_VISIT: "".concat(apiUrl, "/bo-visit/updatevisit"),
    UPDATESTATUS_VISIT: "".concat(apiUrl, "/bo-visit/updatestatusvisit"),
    DETAIL_VISIT: "".concat(apiUrl, "/bo-visit/getdataeditvisit"),
    UPLOAD_VISIT: "".concat(apiUrl, "/bo-visit/upload_visit"),
    BRANDS_CATE: "".concat(apiUrl, "/get-sys/brand/bybook"),
    REPORT_BRAND: "".concat(apiUrl, "/report/orderbybrandv2"),
    REPORT_PRODUCT: "".concat(apiUrl, "/report/orderbyproduct"),
    REPORT_RESERVE_PRODUCT_SUMMARY: "".concat(apiUrl, "/report/reserveproductsummary"),
    REPORT_PRODUCT_NOT_READY_DELIVERY_DATALIST: "".concat(apiUrl, "/report/product-not-ready-delivery/datalist"),
    REPORT_PRODUCT_NOT_READY_DELIVERY_WIDGET: "".concat(apiUrl, "/report/product-not-ready-delivery/widget"),
    REPORT_PRODUCT_NOT_READY_DELIVERY_EXPORT_EXCEL: "".concat(apiUrl, "/report/product-not-ready-delivery/export-excel"),
    REPORT_SHIPPING_COST_AUDIT: "".concat(apiUrl, "/report/shipping-cost-audit"),
    REPORT_SALESHOP: "".concat(apiUrl, "/report/saleshop"),
    REPORT_SALESKU: "".concat(apiUrl, "/report/salesku"),
    REPORT_RESERVATION_PERFORMANCE_MONTHLY: "".concat(apiUrl, "/report/reservation-performance-monthly"),
    REPORT_RESERVATION_WORK_TRACKING: "".concat(apiUrl, "/report/reservation-work-tracking"),
    REPORT_SKU_ACTUAL_DELIVERY_MONTHLY: "".concat(apiUrl, "/report/sku-actual-delivery-monthly"),
    REPORT_SKU_GIFT_MONTHLY: "".concat(apiUrl, "/report/sku-gift-monthly"),
    REPORT_SKU_ACTUAL_DELIVERY_MONTHLY_BY_SHOP: "".concat(apiUrl, "/report/sku-actual-delivery-monthly-by-shop"),
    REPORT_SALESHOP_DETAIL: "".concat(apiUrl, "/report/saleshopdetail"),
    REPORT_CHARTPARTNER: "".concat(apiUrl, "/report/chartpartner"),
    REPORT_CHARTBRANCH: "".concat(apiUrl, "/report/chartbranch"),
    REPORT_CHARTBRANCHDAY: "".concat(apiUrl, "/report/chartbranchbyday"),
    REPORT_CHARTSKU: "".concat(apiUrl, "/report/chartsku"),
    REPORT_BRANDDETAIL: "".concat(apiUrl, "/report/orderbybranddetail"),
    REPORT_CHARTRESERVE: "".concat(apiUrl, "/report/chartreserve"),
    GET_VISITTOTAL: "".concat(apiUrl, "/bo-visit/getdatavisittotal"),
    REPORT_SALESKUNEW: "".concat(apiUrl, "/report/salesku/listsnew"),
    REPORT_SALESKUOLD: "".concat(apiUrl, "/report/salesku/listsold"),
    REPORT_CHARTRESERVEDAY: "".concat(apiUrl, "/report/chartreservebyday"),
    REPORT_CHARTSKUDAY: "".concat(apiUrl, "/report/chartskubyday"),
    REPORT_CHARTPARTNERDAY: "".concat(apiUrl, "/report/chartpartnerbyday"),
    REPORT_CHARTRESERVEVISIT: "".concat(apiUrl, "/report/salevisitandreserve"),
    REPORT_CHARTRESERVEVISIT_BY_SALE: "".concat(apiUrl, "/report/salevisitandreservebysale"),
    RESERVATION_UPDATE_LISTSTOCK: "".concat(apiUrl, "/bo-rsreserve/updatersreservestock"),
    PRODUCT_CHECK_LOCK: function(reservationId) {
        return "".concat(apiUrl, "/product-check/").concat(reservationId, "/lock");
    },
    PRODUCT_CHECK_HEARTBEAT: function(reservationId) {
        return "".concat(apiUrl, "/product-check/").concat(reservationId, "/heartbeat");
    },
    PRODUCT_CHECK_RELEASE: function(reservationId) {
        return "".concat(apiUrl, "/product-check/").concat(reservationId, "/release");
    },
    PRODUCT_CHECK_QUANTITY: function(reservationId) {
        return "".concat(apiUrl, "/product-check/").concat(reservationId, "/quantity");
    },
    PRODUCT_CHECK_VIDEO_RESULT: function(reservationId) {
        return "".concat(apiUrl, "/product-check/").concat(reservationId, "/video-result");
    },
    PRODUCT_CHECK_COMPLETE: function(reservationId) {
        return "".concat(apiUrl, "/product-check/").concat(reservationId, "/complete");
    },
    PRODUCT_CHECK_LOGS: function(reservationId) {
        return "".concat(apiUrl, "/product-check/").concat(reservationId, "/logs");
    },
    SUMMARYCATALOG: "".concat(apiUrl, "/catalog/get-catalog-summary"),
    REPORT_SALEINTENTBRANCH: "".concat(apiUrl, "/report/saleintendantbranch"),
    REPORT_SALEINTENTBRANCH_ORDER_NOTE: "".concat(apiUrl, "/report/saleintendantbranch/order-note"),
    REPORT_BRANDALL: "".concat(apiUrl, "/report/brandall"),
    REPORT_BRANDALLSUMMARY: "".concat(apiUrl, "/report/brandallsummary"),
    REPORT_VISITSALEMONTH: "".concat(apiUrl, "/report/visitsalemonth"),
    REPORT_VISITSALEMONTHLIST: "".concat(apiUrl, "/report/visitsalemonthlist"),
    REPORT_PURCHASE_PENDING_CONFIRM: "".concat(apiUrl, "/report/purchasependingconfirm"),
    UPLOADSTATUS_CONTINUE: "".concat(apiUrl, "/bo-pd-product/updatestatuscontinue"),
    IMPORT_INVOICE_MT_INFO: "".concat(apiUrl, "/bo-import/post-datalist-mt-inv"),
    IMPORT_INVOICE_MT_UPLOAD: "".concat(apiUrl, "/bo-import/preview-mt"),
    IMPORT_INVOICE_MT_CONFIRM: "".concat(apiUrl, "/bo-import/confirm-mt"),
    IMPORT_INVOICE_TT_INFO: "".concat(apiUrl, "/bo-import/post-datalist-tt-inv"),
    IMPORT_INVOICE_TT_UPLOAD: "".concat(apiUrl, "/bo-import/preview-tt"),
    IMPORT_INVOICE_TT_CONFIRM: "".concat(apiUrl, "/bo-import/confirm-tt"),
    IMPORT_PRODUCT_MT_INFO: "".concat(apiUrl, "/bo-import/post-datalist-mt-product"),
    IMPORT_PRODUCT_MT_UPLOAD: "".concat(apiUrl, "/bo-import/preview-product-mt"),
    IMPORT_PRODUCT_MT_CONFIRM: "".concat(apiUrl, "/bo-import/confirm-product-mt"),
    IMPORT_PRODUCT_TT_INFO: "".concat(apiUrl, "/bo-import/post-datalist-tt-product"),
    IMPORT_PRODUCT_TT_UPLOAD: "".concat(apiUrl, "/bo-import/preview-product-tt"),
    IMPORT_PRODUCT_TT_CONFIRM: "".concat(apiUrl, "/bo-import/confirm-product-tt"),
    REPORT_INVOICE_MT_INFO: "".concat(apiUrl, "/bo-import/mt-inv-monthly-summary"),
    REPORT_INVOICE_TT_INFO: "".concat(apiUrl, "/bo-import/tt-inv-monthly-summary"),
    REPORT_PRODUCT_MT_INFO: "".concat(apiUrl, "/bo-import/mt-product-monthly-summary"),
    REPORT_PRODUCT_TT_INFO: "".concat(apiUrl, "/bo-import/tt-product-monthly-summary")
};
